import {
  ArrowDropDown,
  ArrowDropUp,
  Chat,
} from "@mui/icons-material";
import RemoveChannelModal from "../modals/RemoveChannelModal";
import EditChannelModal from "../modals/EditChannelModal";
import { useState, useEffect } from "react";
import {
  formatTimestamp,
  formatTimestampForZone,
} from "../utils/formattimestamp";
import { formatPhoneNumber } from "../utils/formatnumber";
import { jwtDecode } from "jwt-decode";
import decryptApi from "../utils/decryptApi";
import { Mail, Pencil, Phone, Trash2 } from "lucide-react";

const ChannelList = ({
  channels,
  setChannels,
  channelUpdatedModal,
  setOpenChannelUpdatedModal,
}) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction:
        prevConfig.key === key && prevConfig.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  const sortedRows = [...channels].sort((a, b) => {
    if (sortConfig.key) {
      const isAscending = sortConfig.direction === "asc";
      const aValue = a.M[sortConfig.key]?.S?.toLowerCase?.() || ""; // Handles case-insensitive comparison
      const bValue = b.M[sortConfig.key]?.S?.toLowerCase?.() || "";

      if (aValue < bValue) return isAscending ? -1 : 1;
      if (aValue > bValue) return isAscending ? 1 : -1;
    }
    return 0;
  });

  const renderSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? (
        <ArrowDropUp fontSize="small" />
      ) : (
        <ArrowDropDown fontSize="small" />
      );
    }
    return <ArrowDropDown fontSize="small" className="opacity-50" />; // default icon
  };

  // Remaining code is unchanged

  const [currentIndex, setCurrentIndex] = useState(0);
  const [openEditChannelModal, setOpenEditChannelModal] = useState(false);
  const [openDeleteChannelModal, setOpenDeleteChannelModal] = useState(false);

  // Reset currentIndex when list shrinks (e.g. after delete) to avoid passing undefined channel_data
  useEffect(() => {
    if (sortedRows.length > 0 && currentIndex >= sortedRows.length) {
      setCurrentIndex(Math.max(0, sortedRows.length - 1));
    }
  }, [sortedRows.length, currentIndex]);

  const handleCloseMenu = () => {};

  // const [visibleIndexes, setVisibleIndexes] = useState({});

  // const toggleVisibility = (index) => {
  //   setVisibleIndexes((prev) => ({
  //     ...prev,
  //     [index]: !prev[index], // Toggle the visibility for the specific index
  //   }));
  // };

  async function decodeToken(token) {
    try {
      const dc = await decryptApi(token);
      return dc;
    } catch (error) {
      // Log when channel token is corrupt or decrypt fails
      console.error("Invalid token:", error);
      return null;
    }
  }

  return (
    <div className="w-full overflow-x-auto lg:overflow-auto shadow-xs border-[1px] rounded-[6px]  ">
      <div className="no-borders w-full" style={{ minWidth: "900px" }}>
        <div>
          <div className="grid grid-cols-10 text-[14px] text-[#030229] font-[400] bg-[#F9FAFB] px-4 py-3">
            <div
              className="   cursor-pointer col-span-2 text-gray-500 font-semibold"
              // onClick={() => handleSort("type")}
            >
              CHANNEL
            </div>
            <div
              className="   cursor-pointer col-span-3 text-gray-500 font-semibold"
              // onClick={() => handleSort("label")}
            >
              DESCRIPTION
            </div>
            <div
              className="  cursor-pointer col-span-2 text-gray-500 font-semibold"
              // onClick={() => handleSort("details")}
            >
              STATUS
            </div>
            <div
              className="   cursor-pointer col-span-2 text-gray-500 font-semibold"
              // onClick={() => handleSort("last_updated")}
            >
              SETTINGS
            </div>

            <div className="  cursor-pointer col-span-1 text-gray-500 font-semibold">
              ACTION
            </div>
          </div>
        </div>
        <div>
          {channels && sortedRows.length > 0 ? (
            sortedRows.map((row, index) => {
              return (
                <div
                  key={index}
                  className={
                    "bg-white grid grid-cols-10 border-b-[1px]  py-4  px-4 text-[14px] items-center hover:bg-[#F9FAFB] "
                  }
                  sx={{ border: "none" }}
                >
                  <div className="col-span-2 flex items-center space-x-2 ">
                    {row.M.type.S === "email" && (
                      <Mail className="w-[25px] object-cover text-[#3B82F6]" />
                    )}
                    {row.M.type.S === "slack" && (
                      <img
                        src="/icons/slack.png"
                        className="text-[#4F46E5] mr-2 w-[25px] h-[25px]"
                      />
                    )}
                    {row.M.type.S === "front" && (
                      <img
                        src="/icons/front.png"
                        className="text-[#4F46E5] mr-2 w-[35px] h-[35px]"
                      />
                    )}
                    {row.M.type.S === "sms" && (
                      <Chat className="text-green-500" />
                    )}
                    {row.M.type.S === "forward_number" && (
                      <Phone className="w-[25px] object-cover text-[#6366F1]" />
                    )}
                    {row.M.type.S === "elevenlabs" && (
                      <img
                        src="/icons/elevenlabs.svg"
                        alt="Eleven Labs"
                        className="w-[25px] h-[25px]"
                      />
                    )}

                    <div className=" ">
                      <div className="font-semibold text-[15px]">
                        {" "}
                        {row.M.label.S}{" "}
                      </div>
                      <div className="text-[13px]">
                        {row.M.type.S === "forward_number" && "Forward Number"}
                        {row.M.type.S === "email" && "Email"}
                        {row.M.type.S === "slack" && "Slack"}
                        {row.M.type.S === "front" && "Front"}
                        {row.M.type.S === "sms" && "SMS"}
                        {row.M.type.S === "elevenlabs" && "Eleven Labs AI Agent"}
                      </div>
                    </div>
                  </div>
                  <div className="col-span-3">
                    {row.M.type.S === "forward_number" ||
                    row.M.type.S === "sms" ? (
                      formatPhoneNumber(row.M.value.S)
                    ) : row.M.type.S === "elevenlabs" ? (
                      (() => {
                        try {
                          const ids = JSON.parse(row.M.value?.S || "[]");
                          return Array.isArray(ids)
                            ? `${ids.length} agent${ids.length !== 1 ? "s" : ""} enabled`
                            : row.M.value?.S || "—";
                        } catch {
                          return row.M.value?.S || "—";
                        }
                      })()
                    ) : (
                      <>
                        {row.M.type.S === "slack"
                          ? row.M.value.S
                          : row.M.value.S}
                      </>
                    )}
                  </div>
                  <div className="col-span-2" id={"123-" + index}>
                    {row.M.status.S === "pending" && (
                      <div className="bg-[#F3F4F6] text-[#1F2937] w-fit   text-[12px] lg:text-[13px] px-3 text-center font-semibold rounded-[15px] ">
                        Not Connected
                      </div>
                    )}
                    {row.M.status.S === "active" && (
                      <div className="bg-[rgba(0,186,37,0.1)] text-[#166534] w-fit   text-[12px] lg:text-[13px] px-3 text-center font-semibold rounded-[15px] ">
                        Connected
                      </div>
                    )}
                    {row.M.status.S === "error" && (
                      <div className="text-[#E71D36] bg-[rgba(231,29,54,0.1)] text-center py-2 rounded-[20px]">
                        Error
                      </div>
                    )}
                  </div>
                  <div className="col-span-2">
                    <div className="flex items-center">
                      {formatTimestampForZone(row.M.last_updated.S)}
                    </div>
                  </div>

                  <div className="col-span-1 flex items-center gap-1">
                    <button
                      onClick={() => {
                        setCurrentIndex(index);
                        setOpenEditChannelModal(true);
                      }}
                      className="flex items-center gap-1 px-2 py-1 rounded border border-[#3d75ce] text-[#3265b7] hover:bg-[#DBEAFE] text-[14px] font-semibold"
                    >
                      <Pencil className="w-[15px] h-[16px]" />
                      Edit
                    </button>
                    <button
                      onClick={() => {
                        setCurrentIndex(index);
                        setOpenDeleteChannelModal(true);
                      }}
                      className="flex items-center gap-1 px-2 py-1 rounded border border-[#FCA5A5] text-[#B91C1B] hover:bg-[#FEE2E2] text-[14px] font-semibold"
                    >
                      <Trash2 className="w-[15px] h-[16px]" />
                      Delete
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-[12px] lg:text-[13px] text-center pt-3">
              You do not have any channels created yet. Click the "Add Channel"
              button to create one. Need help?
              <a
                className="text-blue-800 hover:underline"
                href="mailto:hello@twilanswer.com"
              >
                {" "}
                Contact Support
              </a>
              .
            </div>
          )}
        </div>
      </div>
      {sortedRows.length > 0 && (
        <>
          <EditChannelModal
            open={openEditChannelModal}
            setOpen={setOpenEditChannelModal}
            channel_data={sortedRows[currentIndex]?.M}
            setChannels={setChannels}
            closeMenu={handleCloseMenu}
            index={currentIndex}
            channelUpdatedModal={channelUpdatedModal}
            setOpenChannelUpdatedModal={setOpenChannelUpdatedModal}
          />
          <RemoveChannelModal
            open={openDeleteChannelModal}
            setOpen={setOpenDeleteChannelModal}
            channel_data={sortedRows[currentIndex]?.M}
            setChannels={setChannels}
            closeMenu={handleCloseMenu}
            index={currentIndex}
          />
        </>
      )}
    </div>
  );
};
export default ChannelList;
